/**
 * Tâche 1305 (Eric 2026-06-30) — Les derniers identifiants cherchés, sous le
 * champ de recherche, pour y revenir en un clic.
 *
 * Rien ne s'affiche quand la liste est vide : une rangée vide laisserait
 * croire à une fonction cassée.
 */
import React from "react";
import { X, ClockCounterClockwise } from "@phosphor-icons/react";

export const RecentIdSearches = ({ items, onPick, onForget, testidPrefix = "recent-id" }) => {
  if (!items || items.length === 0) return null;
  return (
    <div
      className="flex items-center gap-1.5 flex-wrap mt-1.5"
      data-testid={`${testidPrefix}-searches`}
    >
      <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-wider text-zinc-400 font-semibold">
        <ClockCounterClockwise size={11} weight="bold" />
        Identifiants récents
      </span>
      {items.map((entry) => (
        <span
          key={entry.id}
          className="inline-flex items-center gap-1 pl-2 pr-1 py-0.5 rounded-full border border-zinc-200 bg-white text-[11px] text-zinc-700 hover:border-[#002FA7] transition-colors"
          data-testid={`${testidPrefix}-chip-${entry.id}`}
        >
          <button
            type="button"
            onClick={() => onPick?.(entry)}
            className="inline-flex items-center gap-1.5 max-w-[240px]"
            title={`${entry.title || "Sans titre"} — ${entry.id}`}
            data-testid={`${testidPrefix}-pick-${entry.id}`}
          >
            <span className="truncate">{entry.title || "Sans titre"}</span>
            <span className="font-mono text-[10px] text-[#002FA7]">{entry.id.slice(0, 8)}</span>
          </button>
          <button
            type="button"
            onClick={() => onForget?.(entry.id)}
            className="text-zinc-400 hover:text-rose-600 p-0.5 rounded-full"
            title="Oublier cet identifiant"
            aria-label="Oublier cet identifiant"
            data-testid={`${testidPrefix}-forget-${entry.id}`}
          >
            <X size={10} weight="bold" />
          </button>
        </span>
      ))}
    </div>
  );
};

export default RecentIdSearches;
